module.exports = __webpack_public_path__ + "b2d34127950867e1e977bf683adf143c.jpg";